import { Route } from '@angular/router';
import { VehicleTypesService } from '../api/services/vehicle-types.service';
import { TravelPricingListComponent } from './components/travel-pricing-list/travel-pricing-list/travel-pricing-list.component';
import { TravelPricingService } from '../api/services/travel-pricing.service';
import { UploadImageService } from '../api/services/upload-image.service';

export default [
  {
    path: '',
    component: TravelPricingListComponent,
    providers: [VehicleTypesService, TravelPricingService, UploadImageService],
  },
] as Route[];
